// Cifra en el navegador lo sensible (credenciales de AWS) antes de enviarlo: AES-256-GCM con una clave aleatoria, y esa clave
// protegida con la clave publica RSA del servidor (OAEP/SHA-256). Funciona tambien en HTTP (no usa crypto.subtle).
// El formato lo descifra services/server-emp/src/mod_aws_arq/cripto.js.
import forge from "node-forge";

export const cifrarParaServidor = (objeto, clavePublica) => {
    const pub = forge.pki.publicKeyFromPem(clavePublica.pem);
    const clave = forge.random.getBytesSync(32), iv = forge.random.getBytesSync(12);
    const cifrador = forge.cipher.createCipher("AES-GCM", clave);
    cifrador.start({ iv });
    cifrador.update(forge.util.createBuffer(forge.util.encodeUtf8(JSON.stringify(objeto))));
    cifrador.finish();
    const ek = pub.encrypt(clave, "RSA-OAEP", { md: forge.md.sha256.create(), mgf1: { md: forge.md.sha256.create() } });
    return {
        id: clavePublica.id,
        ek: forge.util.encode64(ek), iv: forge.util.encode64(iv),
        ct: forge.util.encode64(cifrador.output.getBytes()), tag: forge.util.encode64(cifrador.mode.tag.getBytes()),
    };
};

// Pide la clave publica al servidor (post() devuelve la respuesta de /cuentaClavePublica) y devuelve el sobre cifrado.
export const sobreCifrado = async (post, datos) => {
    const r = await post();
    const clave = r && r.rows && r.rows[0];
    if (!clave) throw new Error("No se pudo obtener la clave de cifrado del servidor.");
    return cifrarParaServidor(datos, clave);
};
